import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'spw-header-persona-item',
  styleUrl: 'spw-header-persona-item.scss',
  shadow: true,
})
export class SpwHeaderPersonaItem {
  @Prop({ reflect: true }) active: boolean = false;

  render() {
    return (
      <Host>
        <div class={{ 'spw-header-persona-item': true, 'spw-header-persona-item--active': this.active }}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
